<template lang="">
    <div class="row justify-content-center">
        <div class="col-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
            <innerHeaderDiy/>
            <confirmPay/>
            
        </div>
        
    </div>
</template>
<script>
import confirmPay from "../components/read-only-page/read-only-proposal-details.vue"
import innerHeaderDiy from "@/components/header/innerHeaderDiy.vue";

export default {
   components:{
    confirmPay,
    innerHeaderDiy,
   }
}
</script>
<style lang="">
    
</style>